/**
 * 密码强度策略（2026-10-28 与 Casdoor 托管注册页对齐）
 *
 * Casdoor 组织 luminote 的 passwordOptions：至少 8 字符 + 至少一个大写字母 +
 * 至少一个小写字母 + 至少一个数字。App 内所有「设置新密码」入口
 * （绑定邮箱页 / 设置·账号安全 / 服务端 /huawei/bind、/auth/set-credentials）
 * 统一按此校验，与 Casdoor 托管注册页要求保持一致，避免各入口强度要求不一致。
 *
 * ★ 仅用于「设置新密码」场景；登录 / 验证已有密码不得调用
 *   （历史弱密码用户必须仍可登录，只在新设密码时要求满足强度）。
 */
export const PASSWORD_POLICY_HINT =
  '密码需 8-64 位，且包含至少一个大写字母、一个小写字母和一个数字'

/** 是否满足密码强度策略（8-64 位 + 大写 + 小写 + 数字） */
export function isPasswordCompliant(password: string): boolean {
  return (
    typeof password === 'string' &&
    password.length >= 8 &&
    password.length <= 64 &&
    /[A-Z]/.test(password) &&
    /[a-z]/.test(password) &&
    /[0-9]/.test(password)
  )
}
